import React, { Component } from 'react';
import { connect } from 'react-redux';

import GalleryItem from './GalleryItem';
import LoadingIcon from '../../../common/icons/LoadingIcon';

import styles from './_styles/ResultsGallery.module.scss';

const allActionCreators = Object.assign({});

export class ResultsGallery extends Component {

	render() {
		return <div className={styles.ResultsGallery}>
			<div className={styles.galleryWrapper}>
				<div className={styles.body}>
					{this.props.dataCount === 0 
						?	<div className={styles.noResultsWrapper}>
								<div className={`${styles.noResults} FlexCenter`}>No results found</div>
							</div>
						:	<div className={styles.resultsWrapper}>
								{this.props.dataResults?.map((result, i) => {
									return <div key={i} className={styles.individualResult}>
										<GalleryItem
											keyMod={i}
											product={result} />
									</div>
								})}
							</div>
					}
				</div>
				{this.props.dataPending && (
					<div className={styles.loading}>
						<div className={styles.iconWrapper}>
							<LoadingIcon />
						</div>
					</div>
				)}
			</div>
		</div>;
	}
}

function mapStateToProps(state) {
	return {

	};
}

export default connect(mapStateToProps, allActionCreators)(ResultsGallery);